// const base = 'http://localhost/w/vue/src/s/s2/';
const base = 'https://sjana.losenviskas.com/src/s/s2/';
const Url = base+'public/api/';
const iUrl = base+'storage/app/';

// const themeDefault = 'dark'
// const namesOfModes = ['dark', 'moonlight', 'eclipse', 'light']

export { Url, iUrl, }